/**
 * Floating island bottom nav clearance (pill height + bottom margin + logo overhang).
 * Content should leave this much space so tabs / CTAs are not hidden under the island.
 */
export const MOBILE_BOTTOM_NAV_CLEARANCE = 'calc(88px + env(safe-area-inset-bottom, 0px))';

/** Same clearance without safe-area when the parent already accounts for it, or for fixed px layouts. */
export const MOBILE_BOTTOM_NAV_CLEARANCE_PX = 88;
